import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = r((c, e) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: e,
    ...c,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4183",
              width: 34,
              height: 32,
              x: 7,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M39.76 38.7c-5.22-4.9-14.05-5.15-15.76-5.15-5.94 0-11.67 1.86-15.72 5.11-.32.26-.38.73-.12 1.05.15.19.37.29.59.29.16 0 .33-.05.47-.17 3.79-3.03 9.18-4.78 14.78-4.78 1.62 0 9.93.23 14.74 4.74.3.28.78.27 1.06-.03s.27-.77-.04-1.06M8.75 19.25c.41 0 .75-.34.75-.75 0-.63.76-1.17 1.67-1.17s1.67.54 1.67 1.17c0 .41.34.75.75.75s.75-.34.75-.75c0-.63.76-1.17 1.67-1.17.41 0 .75-.34.75-.75s-.34-.75-.75-.75c-.97 0-1.84.38-2.42.97-.58-.59-1.45-.97-2.42-.97-.48 0-.93.1-1.33.26a9 9 0 0 1 5.13-5.89c-.74 1.1-1.33 2.57-1.71 4.33-.09.4.17.8.57.89.41.08.8-.17.89-.58.57-2.61 1.72-4.55 2.95-5.14v4.99c0 .41.34.75.75.75s.75-.34.75-.75V9.7c1.24.58 2.39 2.52 2.96 5.15.08.35.39.59.73.59.05 0 .11 0 .16-.02.4-.09.66-.49.58-.89-.38-1.76-.97-3.23-1.71-4.32a9.02 9.02 0 0 1 5.12 5.88c-.41-.16-.86-.26-1.33-.26-.97 0-1.84.38-2.42.96-.58-.59-1.44-.97-2.42-.97-1.75 0-3.17 1.2-3.17 2.67v13.08c0 .41.34.75.75.75s.75-.34.75-.75V18.5c0-.63.76-1.17 1.67-1.17s1.67.54 1.67 1.17c0 .41.34.75.75.75s.75-.34.75-.75c0-.63.76-1.17 1.67-1.17s1.67.54 1.67 1.17c0 .41.34.75.75.75s.75-.34.75-.75c0-5.79-4.68-10.5-10.42-10.5C12.68 8 8 12.71 8 18.5c0 .41.34.75.75.75M36.21 15.58c2.09 0 3.79-1.7 3.79-3.79S38.3 8 36.21 8s-3.79 1.7-3.79 3.79 1.7 3.79 3.79 3.79m0-6.08c1.26 0 2.29 1.03 2.29 2.29s-1.03 2.29-2.29 2.29-2.29-1.03-2.29-2.29 1.03-2.29 2.29-2.29"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4183)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyPalmTreeIcon";
export {
  t as AgencyPalmTreeIcon,
  t as default
};
//# sourceMappingURL=index.js.map
